export default __webpack_public_path__ + "static/2-917d8be5bc206bedde7abf028436e5b9.png";